<template>
<div class="copy_setting" @click="openDialog">
        <svg-icon name="dir-setting"></svg-icon>{{$t("设置")}}    </div>
    <!-- 分割线 -->
    <div class="split_line"></div>
    <!-- 弹窗 -->
    <a-modal v-model:visible="showDialog" :simple="true" :footer="false" :header="false" :render-to-body="false" modalClass="file_share_copy_setting_dialog">
        <div class="dialog_title">
            <div>{{$t("权限设置")}}</div>
            <div class="close-btn" @click.stop="closeShareView">
                <img src="@/assets/img/share/icon_file_close.png"/>
            </div>
        </div>
        <div class="who_can_copy">
            <div style="font-weight: 500;">{{$t("谁可以复制内容")}}</div>
            <a-dropdown class="file_share_copy_setting_dialog_dropdown" trigger="click" @popup-visible-change="handleDropdownVisibleChange" @select="cmd => selectAuth(cmd)">
                <button class="file_share_copy_setting_dialog_button">
                    <span>{{ COPY_PERMISSION.find((item) => item.id === copyPermission).name }}</span>
                    <img :src="EditableIcon" :style="{
                            transform: dropdownVisible
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)'
                        }"/>
                </button>
                <template #content>
                    <div class="auth-list" v-for="(auth, i) in COPY_PERMISSION" :key="i">
                        <a-doption :value="auth.id">
                            <div class="permission-name">
                                <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
                                    <div>
                                        <div style="line-height: 1.3; margin-top: 4px;">{{ auth.name }}</div>
                                        <div style="font-size: 12px; color: #999; line-height: 1.3; margin-top: 2px; margin-bottom: 10px;">{{ auth.desc }}</div>
                                    </div>
                                    <img class="permission-selected-icon" v-show="copyPermission === auth.id" src="@/assets/img/share/icon_file_selected.png"/>
                                </div>
                            </div>
                        </a-doption>
                    </div>
                </template>
            </a-dropdown>
        </div>
    </a-modal>
</template>

<script lang="ts" setup="true">
import { intl } from 'tci18n-vue3'
import { ref, computed, onMounted } from 'vue';
import EditableIcon from '@/assets/img/share/icon_file_auth_editable.png';
import { store } from '../../store/store';
import { getCopyAuth, setCopyAuth } from '../../core/api/file';
// @ts-ignore
import { COPY_PERMISSION } from '@/constants/FileShare';
import { Message } from '@toca/arco-design-web-vue';

const props = defineProps<{
  fileId: string;}>();


onMounted(() => {
  getCopyAuth(props.fileId).then((res) => {
    if (res.data.code === 200) {
      store.commit('kbEditModule/SET_COPY_PERMISSION', res.data.data.copyEntity);
    }
  });
});

const copyPermission = computed(() => store.state.kbEditModule.copyPermission);

// 模态框显示控制
const showDialog = ref(false);
function openDialog() {
  showDialog.value = true;
}
function closeShareView() {
  showDialog.value = false;
}
// 下拉框显示控制
const dropdownVisible = ref(false);
function handleDropdownVisibleChange(visible: boolean) {
  dropdownVisible.value = visible;
}

// 选择权限
function selectAuth(cmd: string) {
  // store.commit('kbEditModule/SET_COPY_PERMISSION', cmd);
  const currentPermission = copyPermission;
  const selectedPermission = cmd;
  // 设置后立即生效
  store.commit('kbEditModule/SET_COPY_PERMISSION', selectedPermission);
  setCopyAuth(props.fileId, {
    copyEntity: selectedPermission }).

  then((res) => {
    if (res.data.code === 200) {
      Message.success(intl.$t("操作成功"));
    } else {
      Message.error(intl.$t("操作失败"));
      store.commit('kbEditModule/SET_COPY_PERMISSION', currentPermission);
    }
  }).
  catch((err) => {
    Message.error(intl.$t("操作失败"));
    store.commit('kbEditModule/SET_COPY_PERMISSION', currentPermission);
  });
}
</script>

<style lang="scss" scoped>
.copy_setting {
    display: flex;
    align-items: center;
    padding: 4px 6px;
    border-radius: 4px;
    cursor: pointer;

    svg {
        width: 16px;
        height: 16px;
        margin-right: 2px;
    }

    &:hover {
        background: #f4f6f9;
    }
}
.split_line {
    width: 1px;
    height: 16px;
    margin: 0 10px;
    border-radius: 1px;
    background: #e2e6ed;
}
.dialog_title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 16px;
    color: #121317;
    line-height: 24px;

    .close-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        padding: 4px;
        border-radius: 4px;
        box-sizing: border-box;

        &:hover {
            background: #f4f6f9;
        }
    }

    img {
        width: 14px;
        height: 14px;
        cursor: pointer;
    }
}
.who_can_copy {
    display: flex;
    justify-content: space-between;
}
.file_share_copy_setting_dialog_button {
    min-width: 145px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 8px;
    border-radius: 4px;
    background: #f4f6f9;
    font-size: 14px;
    color: #121317;
    cursor: pointer;
    outline: none;
    border: none;

    span {
        max-width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    img {
        width: 12px;
    }

    &:hover {
        background: #eceef2;
    }
}
</style>

<style lang="scss">
.file_share_copy_setting_dialog {
    min-height: 290px !important;
    background-color: #fff !important;
    border-radius: 10px !important;
    border: 1px solid #e6e8ec !important;
    box-shadow: 0 8px 12px 0 rgba(18, 19, 23, 0.1);
    padding: 16px !important;

    .arco-modal-header {
        display: none;
    }
}

.file_share_copy_setting_dialog_dropdown {
    .arco-dropdown {
        width: unset !important;
    }
    .arco-dropdown {
        padding: 4px !important;
    }
    .arco-dropdown-option {
        border-radius: 4px !important;
        min-width: 134px;
    }
    .arco-dropdown-option-content {
        flex: 1;
    }
}
.permission-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.permission-selected-icon {
    width: 14px;
    margin-top: 10px;
}
</style>
